// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { requestRmaConfirmationReturnLabelStyles } from "@west/App/Widgets/RequestRmaConfirmation/RequestRmaConfirmationReturnLabel";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

requestRmaConfirmationReturnLabelStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
requestRmaConfirmationReturnLabelStyles.returnLabelContainer = {
    css: css`
        padding: 16px;
        border: 1px solid ${getColor("common.border")};
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 32px;
    `,
};
requestRmaConfirmationReturnLabelStyles.returnLabelHeaderText = {
    variant: "h2",
    css: css`
        margin-bottom: 16px;
    `,
};
requestRmaConfirmationReturnLabelStyles.returnLabelSubText = {
    size: 16,
    lineHeight: "26px",
    css: css`
        margin-bottom: 16px;
    `,
};

requestRmaConfirmationReturnLabelStyles.printLabelButton = {
    css: css`
        margin-right: auto;
        ${xScreen("gte", "md")} {
            flex: 0 0 auto;
        }
    `,
};
